import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from './auth'

export const reportsApi = createApi({
  baseQuery: baseQuery(),
  reducerPath: 'reportsApi',
  endpoints: (builder) => ({
    getFinalReportFields: builder.query<ReportField[], void>({
      query: () => `/reports/v1.0/fields/`,
    }),
  }),
})

export const { useLazyGetFinalReportFieldsQuery } = reportsApi
